import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { SpinnerWrapper } from '../../tutoringV2Styled';
import { ManageTutorsCategoryData } from '../../tutoringV2CommonUtils';
import { ButtonSpinner, ButtonSpinnerProgress } from 'components/Ui/styled';

const TutorDialogCard = ({
  tutor,
  loading,
  getTutorName,
  onRemoveTutor,
  onSwitchCategory,
}) => {
  const tutorName = getTutorName(tutor?.tutorId);
  const formattedCategory =
    tutor?.category?.charAt(0).toUpperCase() + tutor?.category.slice(1);

  const isPrimary = tutor?.category === 'primary';
  const switchLabel = isPrimary ? 'Backup' : 'Primary';

  return (
    <Grid item xs={12} sm={6}>
      <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
        <Typography variant="h6" fontWeight={600}>
          {tutorName}
        </Typography>

        <ManageTutorsCategoryData
          label="Category :"
          value={formattedCategory}
        />

        <Box
          mt={3}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Button
            variant="outlined"
            size="medium"
            color="primary"
            onClick={() => onSwitchCategory(tutor)}
          >
            → {switchLabel}
          </Button>

          <ButtonSpinner>
            <SpinnerWrapper>
              <Button
                variant="outlined"
                size="medium"
                color="primary"
                disabled={loading}
                onClick={() => onRemoveTutor(tutor)}
              >
                🗑 Remove
              </Button>
              {loading && <ButtonSpinnerProgress size={24} />}
            </SpinnerWrapper>
          </ButtonSpinner>
        </Box>
      </Paper>
    </Grid>
  );
};

export default TutorDialogCard;
